import { createContext, useContext, useState, useEffect } from "react";

const ThemeContext = createContext();

export const useTheme = () => {
  return useContext(ThemeContext);
};

export const ThemeProvider = ({ children }) => {
  // Check if user has a theme preference in localStorage
  const [theme, setTheme] = useState(() => {
    const savedTheme = localStorage.getItem("theme");
    return savedTheme || "light"; // Default to light theme if no preference
  });

  // Update the theme class on the document element
  useEffect(() => {
    // Check if theme is being forced by ThemeOverrideHandler
    const isThemeForced =
      document.documentElement.hasAttribute("data-theme-forced");

    if (!isThemeForced) {
      // Only apply theme if it's not being forced
      document.documentElement.classList.remove("light", "dark");
      document.documentElement.classList.add(theme);
    }

    // Always save to localStorage regardless of override
    localStorage.setItem("theme", theme);
  }, [theme]);

  // Toggle between light and dark themes
  const toggleTheme = () => {
    setTheme((prevTheme) => (prevTheme === "light" ? "dark" : "light"));
  };

  const value = {
    theme,
    toggleTheme,
  };

  return (
    <ThemeContext.Provider value={value}>{children}</ThemeContext.Provider>
  );
};
